<template>
    <mode-switcher
        ref="modeSwitcher"
        :main-mode-text="$t('create')"
        :create-mode-text="$t('commission_creating')"
        :edit-mode-text="$t('commission_editing')"
        @reset="commissionEditModalSelected = null"
    >
        <template v-slot:btn-block>
            <div class="full-width d-flex align-center">
                <v-spacer />
                <FilterStatusToggle v-model="activeFilter" />
            </div>
        </template>
        <template v-slot:main-mode>
            <v-data-table
                :items="commissionsFiltered"
                :headers="headers"
                :loading="isCommissionsLoading"
                class="elevation-1 table-server"
                :sort-by="[{key: 'planName', order: 'asc'}]"
                must-sort
            >
                <template v-slot:item.planName="{item}">
                    <span class="text-link font-weight-medium text-decoration-underline" @click="showEditModal(item)">
                        {{ item.planName }}
                    </span>
                </template>
                <template v-slot:item.active="{item}">
                    <span>
                        {{ item.active ? $t('active') : $t('inactive') }}
                    </span>
                </template>
                <template v-slot:item.dates="{item}">
                    <span>
                        {{ dateRange(item.tariffLinks) }}
                    </span>
                </template>
                <template v-slot:item.actions="{item}">
                    <span>
                        <v-btn variant="text" size="small" color="primary" @click="copyCommission(item)">
                            {{ $t('copy') }}
                        </v-btn>
                    </span>
                </template>
            </v-data-table>
        </template>
        <template v-slot:additional-mode>
            <product-prices-commissions-modal
                :commission="commissionEditModalSelected"
                :contract="contract"
                :selected-locale="selectedLocale"
                @on-close="onCloseEditModal"
                @on-save="onCommissionSave"
            />
        </template>
    </mode-switcher>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Emit} from 'vue-facing-decorator'
    import ProductPricesCommissionsModal from '~/components/supplier/prices/modals/ProductPricesCommissionsModal.vue'
    import {clone} from '~/utils/helpers'

    @Component({
        components: {ProductPricesCommissionsModal},
    })
    export class ProductPricesCommissions extends Vue {
        @Prop() contract
        @Prop() selectedLocale
        @Prop() commissions
        @Prop() isCommissionsLoading

        commissionEditModalSelected = null
        activeFilter = true

        async mounted() {
            await supplierStore.loadProductServices()
        }

        @Emit()
        async onCommissionSave() {}

        showEditModal(commission) {
            this.commissionEditModalSelected = commission
            this.$refs.modeSwitcher.edit()
        }

        onCloseEditModal() {
            this.$refs.modeSwitcher.goToTable()
        }

        copyCommission(commission) {
            const commissionCopied = clone(commission)

            delete commissionCopied.id

            commissionCopied.tariffLinks.forEach(tl => {
                delete tl.linkId
            })

            commissionCopied.extraServiceCommissions.forEach(c => {
                delete c.id
            })

            this.showEditModal(commissionCopied)
        }

        get headers() {
            return [
                {title: this.$t('name'), value: 'planName', sortable: true},
                {title: this.$t('dates'), value: 'dates'},
                {title: this.$t('status'), value: 'active'},
                {title: this.$t('actions'), value: 'actions'},
            ]
        }

        get commissionsFiltered() {
            return this.commissions.filter(el => this.activeFilter === el.active)
        }

        dateRange(tariffs) {
            if (!tariffs.length) return ''
            let earliestDateFrom = tariffs[0].dateFrom
            let latestDateTo = tariffs[0].dateTo

            tariffs.forEach(tariff => {
                if (new Date(tariff.dateFrom) < new Date(earliestDateFrom)) {
                    earliestDateFrom = tariff.dateFrom
                }
                if (new Date(tariff.dateTo) > new Date(latestDateTo)) {
                    latestDateTo = tariff.dateTo
                }
            })

            return `${earliestDateFrom && this.$filters.dateShortFormat(earliestDateFrom)} - ${latestDateTo && this.$filters.dateShortFormat(latestDateTo)}`
        }
    }

    export default ProductPricesCommissions
</script>
